import { ApiV3Service } from 'core-app/core/apiv3/api-v3.service';
import { Injectable } from '@angular/core';
import { ApiV3TagsPaths } from '../apiv3/apiv3-tags-paths';

@Injectable({ providedIn: 'root' })
export class TagsApiV3Service extends ApiV3Service {
  public readonly tags = new ApiV3TagsPaths(this, this.pathHelper.api.v3.apiV3Base);
}
